export const imageOption = [
    {
        label: "Property Found Image",
        value: "propertyImg",
    },
    {
        label: "Property Not Found Image",
        value: "propertyNotFoundImg",
    },
    {
        label: "Notice Image",
        value: "noticeImg",
    },
    {
        label: "Meeting Person Image",
        value: "meetingPersonImg",
    },
];